const url = {
  common: {
    fileUpload: "/wj/upload",
  },
  getAuthCode: "/apiu/v1/verificationCode",
  userLogin: "/apiu/v1/loginNew",
  userForgetAuthCode: "/apiu/v1/resetpwd/auth",
  userForgetPsd: "/apiu/v1/resetpwd",
  getType: "/apiu/v1/user/type",
  getDefaultUser: "/apiu/v1/profile",
  editPerson: "/apiu/v1/userinfo/update",
  updatePsd: "/apiu/v1/password/edit",
  logout: "/apiu/v1/logout",
  bindMobile: "/apiu/v1/bindphone",
  getMobileCode: "/apiu/v1/bindphone/auth",
  // getModules:'/apiu/v1/index/modules',
  getModules: "/module/list",
  getModuleDetail: "/module/incr",
  getCommonNotice: "/portal/message/page",
  getCommonDongtai: "/campusDynamics/page",
  getDongtaiDetailById: "/campusDynamics",
  getNoticeDetailById: "/portal/message",
  //首页
  getHomeDongtai: "/educationalDynamics/page",
  getHomeTongzhi: "/announcement/page",
  getHomeTongzhiDetail: "/announcement",
  getHomeJiaoyuDetail: "/educationalDynamics",
  uploadFile: "/ngxupld",
  getResearch: "/home/researchPageInfo",
  getResearchById: "/home/editInfo",
  getPeixun: "/portal/message/page",
  getPeixunById: "/portal/message",

  //二维码
  getQrcode: "/weixin/api/get/wx/qrcode",
  getQrLogin: "/weixin/api/scan/login",
  getbindQrcode: "/weixin/api/get/wx/account",
  bindQrcode: "/weixin/api/bind/wx",
  unbindQrcode: "/weixin/api/unbind",
  //教育动态
  getJiaoyuDongtaiByID: "/admin/educationalDynamics",
  publishJiaoyuDongtai: "/admin/educationalDynamics/publish",
  getJiaoyuDongtai: "/admin/educationalDynamics/page",
  addJiaoyuDongtai: "/admin/educationalDynamics/insert",
  deleteJiaoyuDongtai: "/admin/educationalDynamics/remove",
  updateJiaoyuDongtai: "/admin/educationalDynamics/update",

  //管理端消息通知
  addManagerTongzhi: "/message/insert",
  getManagerTongzhiByID: "/message",
  publishManagerTongzhi: "/message/publish",
  getManagerTongzhi: "/message/page",
  deleteManagerTongzhi: "/message/remove",
  updateManagerTongzhi: "/message/update",

  //校园动态
  getXiaoyuanDongtaiByID: "/admin/campusDynamics",
  publishXiaoyuanDongtai: "/admin/campusDynamics/publish",
  getXiaoyuanDongtai: "/admin/campusDynamics/page",
  addXiaoyuanDongtai: "/admin/campusDynamics/insert",
  deleteXiaoyuanDongtai: "/admin/campusDynamics/remove",
  updateXiaoyuanDongtai: "/admin/campusDynamics/update",

  //公告管理
  getGonggao: "/admin/announcement/page",
  addGonggao: "/admin/announcement/insert",
  getGonggaoByID: "/admin/announcement/",
  publishGonggao: "/admin/announcement/publish",
  updateGonggao: "/admin/announcement/update",
  deleteGonggao: "/admin/announcement/remove",
  //消息通知
  getNoticeList: "/admin/message/page",
  getTodoList: "/admin/notification/page",
  getTodoDetail: "/admin/notification",
  //管理端点击通知消息
  clickNotice: "/admin/message",

  getCookieSetrole: "/apiu/v1/cookie/setrole",

  // 修改密码模块
  getSchools: "/apiu/v1/schools/queryBySection", //根据学段获取学校
  getEditPwdPhoneCode: "/apiu/v1/user/achievePhoneCodeByAccount", //获取手机验证码
  editPwd: "/apiu/v1/user/updateDefaultPassword", //修改密码
  forgotPwd: "/apiu/v1/user/forgotPassword", //忘记密码

  // 教师详情信息模块
  td_jobTitle: "/apiu/v1/school/chooseJobTitle", //职称
  td_subject: "/apiu/v1/school/chooseSubject", //学科
  td_education: "/apiu/v1/school/chooseEducation", //学历
  td_info: "/apiu/v1/teacher/getTeacherDetail", //教师详情
  td_submit: "/apiu/v1/school/chooseEditTeacher", //提交
  old_weak_chnagepwd: "/apiu/v1/password/change", //弱密码或者三个月修改密码
  phone_authcode: "/apiu/v1/phonelogin/auth", //手机验证码登录时获取验证码
  phone_login: "/apiu/v1/phonelogin/login", //手机验证码登录
};
export default url;
